import { classNames } from "tools/ui";
import { icons } from "./icons";

function IconTable({ name, record, onClickButton }) {
  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClickButton(e, name, record);
  }

  const [Icon, color] = icons[name] || icons["info"];
  return (
    <div className="flex my-auto">
      <button className="mx-auto active:scale-90" key={name} onClick={onClick}>
        <Icon
          className={classNames("h-5 w-5 fill-current", color)}
          aria-hidden="true"
        />
      </button>
    </div>
  );
}

export default IconTable;
